import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapState } from "vuex";
export default {
  name: "lock",
  data: function data() {
    return {
      passwd: "",
      passwdError: false,
      pass: false
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  computed: _objectSpread(_objectSpread({}, mapState({
    userInfo: function userInfo(state) {
      return state.user.userInfo;
    }
  })), mapGetters(["tag", "lockPasswd"])),
  props: [],
  methods: {
    handleLogout: function handleLogout() {
      var _this = this;

      this.$confirm("是否退出系统, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this.$store.dispatch("LogOut").then(function () {
          _this.$router.push({
            path: "/login"
          });
        });
      });
    },
    handleLogin: function handleLogin() {
      var _this2 = this;

      if (this.passwd !== this.lockPasswd) {
        this.passwd = "";
        this.$message({
          message: "解锁密码错误,请重新输入",
          type: "error"
        });
        this.passwdError = true;
        setTimeout(function () {
          _this2.passwdError = false;
        }, 1000);
        return;
      }

      this.pass = true;
      setTimeout(function () {
        _this2.$store.commit("CLEAR_LOCK");

        _this2.$router.push({
          path: _this2.$router.$avueRouter.getPath({
            src: _this2.tag.value
          })
        });
      }, 1000);
    }
  },
  components: {}
};